import React from 'react';
import { Box, Typography } from '@mui/material';
import { useIntl } from 'react-intl';

import { Icons } from '../../../../Themes';
import { formatLabel } from '../../../../Utils/Post/budget';
import CustomIcon from '../../CustomIcon';

function IdeaCostMeta({ post, space }: any) {
  const intl = useIntl();
  const icon = <CustomIcon src={Icons.misc.cash} color="action" />;

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'nowrap',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          mr: 1,
        }}
      >
        {icon}
      </Box>
      <Typography
        variant="body2"
        component="h3"
        color="textSecondary"
        sx={{ fontWeight: 'bold', whiteSpace: 'nowrap' }}
      >
        {formatLabel(intl, post.budget, space.currency.key)}
      </Typography>
    </Box>
  );
}

export default IdeaCostMeta;
